// const osmAutocompleteBaseUrl = 'http://localhost:8000'
const osmAutocompleteBaseUrl = 'https://prod-osm-autocomplete-f4dahpethvauguc4.germanywestcentral-01.azurewebsites.net'

export const searchUrl = `${osmAutocompleteBaseUrl}/search`
export const verifyUrl = `${osmAutocompleteBaseUrl}/verify`

export const osmAutocompleteApiKey = 'tUj7FDFdihLyqbHEGVGU5t2u+QAux7EhTeZG8EVU+VY='

/** Inhalt der Nachbarfelder, den `/search` zum Umsortieren nutzt. Er filtert nicht: ein Tippfehler in PLZ oder Ort kostet keine Vorschlaege. */
export interface StreetSearchHints {
  housenumber?: string | null
  postcode?: string | null
  city?: string | null
}

/** Query-Parameter fuer `/search`. Leere Hinweise fallen weg, eine unvollstaendige PLZ („979“) geht mit. */
export function streetSearchParams(q: string, hints: StreetSearchHints): Record<string, string | number> {
  const params: Record<string, string | number> = { q, limit: 5 }
  for (const key of ['housenumber', 'postcode', 'city'] as const) {
    const wert = hints[key]?.trim()
    if (wert) {
      params[key] = wert
    }
  }
  return params
}

/** Zeile in der Vorschlagsliste. Ohne Hausnummer kein Leerzeichen vor dem Komma. */
export function streetSuggestionLabel(s: { street?: string; housenumber?: string; postcode?: string; city?: string }): string {
  const strasse = [s.street, s.housenumber?.trim()].filter(Boolean).join(' ')
  const ort = [s.postcode, s.city].filter(Boolean).join(' ')
  return [strasse, ort].filter(Boolean).join(', ')
}
